import { StyleSheet } from 'aphrodite/no-important';
export const styles = StyleSheet.create({
    
    content: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "grid",
        width: "950px",
        alignItems: "center",
        justifyContent: "center",
        gridTemplateRows: "repeat(2,min-content)",
    },

    welcomeMessage: {
        textAlign: "center",
        marginTop: "30px",
        marginBottom: "20px",
        fontSize: "20px"
    },

    buttonContainer: {
        display: "grid",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        gridTemplateColumns: "repeat(4,min-content)",
    },
    
    button: {
        padding: "20px 20px 20px 20px",
        color: "white",
        backgroundColor: "rgb(0, 83, 159)",
        margin: "20px",
        borderRadius: "5px",
        fontSize: "24px",
        fontFamily: "greycliff-bold",
        textTransform: "uppercase",
        letterSpacing: "1px",
        "-webkit-font-smoothing": "auto",
        "-moz-osx-font-smoothing": "auto",
        ":hover": {
            cursor: "pointer"
        }
    }

});



// WEBPACK FOOTER //
// ./src/styles/HomePage.ts